import React, { Fragment, useContext, useEffect, useMemo, useState } from 'react';
import Image from 'next/image';
import moment from 'moment';
import { getImgUrl } from '@utils/functions/getImgUrl';
import { EventContext } from 'pages/events';
import { scrollToElement } from '@utils/functions/throttle';
import { Dialog, Transition } from '@headlessui/react';
import ReactPlayer from 'react-player';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import { useDispatch } from '@globalStore/storeProvider';
import { sourceType } from '@components/shared/widgets/ContactUs';
import useStorage from '@utils/hooks/useStorage';
import { BsArrowRepeat } from 'react-icons/bs';
import { Primary } from 'stories/Button.stories';

const Hero = () => {
  const {
    eventStartTime,
    instructor = {},
    eventEndTime,
    description,
    titleHighlights,
    registeredCount,
    registerLink,
    videoLink,
    title,
    eventImage,
    EventStatus,
    recordedVideoLink = null,
    isWorkshop,
    isMasterClass,
    eventId,
    isLoading,
    setLoading,
    setRegisterWithOneClick,
  } = useContext(EventContext);

  const { Name, Designation, CompanyImage, DisplayPicture, pastCompanies } =
    instructor?.data?.[0]?.attributes || {};

  //timing Data
  const [isOpen, setIsOpen] = useState(false);
  const date = moment(eventStartTime).format('ll');
  const hours = ('0' + eventEndTime.diff(eventStartTime, 'hours')).slice(-2);
  const minutes = eventEndTime.diff(eventStartTime, 'minutes') % 60;
  const timings = `${moment(eventStartTime).format('hh:mm A')} to ${moment(eventEndTime).format(
    'hh:mm A'
  )}`;

  const groupImage = instructor?.data?.find((item) => item?.attributes?.Name === 'Group');

  //title data

  function closeModal() {
    setIsOpen(false);
    document.getElementById('modal')?.classList?.remove('modal-open');
  }

  function openModal() {
    setIsOpen(true);
    document.getElementById('modal')?.classList?.add('modal-open');
  }

  const isMobile = useMediaQuery('(max-width: 767.98px)');
  const dispatch = useDispatch();

  const { getItemFromLocal } = useStorage();

  const localFormData = getItemFromLocal('rcb_form_data');

  const isRegisteredKeyExist = getItemFromLocal('isRegistered');
  const registeredEventId = (isRegisteredKeyExist && JSON.parse(isRegisteredKeyExist)) || [];

  const isEventRegister = registeredEventId?.includes(eventId);

  useEffect(() => {
    setLoading(false);
  }, [isRegisteredKeyExist]);

  return (
    <div className="flex w-full flex-col items-center justify-center overflow-hidden">
      <section className="bg-red-50 relative mt-4 flex w-full flex-wrap items-center justify-center gap-8 bg-red-light-1 px-5 pt-12 pb-28  text-center md:gap-11 md:px-16 md:pt-16  md:text-left lg:px-20">
        <section className="flex flex-1 flex-col lg:gap-y-8">
          <h1 className="w-full text-left font-satoshi-bold text-3xl font-extrabold tracking-normal md:leading-10 lg:text-[2rem]">
            {titleHighlights?.map((text) =>
              text.startsWith('{') ? (
                <span key={text} className="text-red">
                  {text.slice(1, -1)}
                </span>
              ) : (
                text
              )
            )}
          </h1>
          <p
            style={{ lineHeight: 1.8 }}
            className="hidden w-full font-satoshi-medium text-base md:block"
          >
            {description}
          </p>
          <div className="hidden flex-wrap items-center justify-center gap-y-4 gap-x-4 md:flex md:justify-start">
            <div className="border-red-600 text-red-600 flex max-w-max items-center whitespace-nowrap border-solid bg-white bg-opacity-60  px-4 py-1.5 font-satoshi-medium font-medium  text-red md:border-l-4">
              <img alt="clock" className="mr-2 h-7" src="/assets/events/clock.png" />
              {hours}
              {minutes ? ` : ${('0' + minutes).slice(-2)}` : ''} Hours
            </div>
          </div>
        </section>
        {/* <section className="mt-auto hidden md:flex">
          <Image
            src={eventImage?.data?.attributes?.url}
            height={200}
            width={250}
            objectFit="contain"
            alt="circle"
            quality={80}
            priority
          />
        </section> */}
        <section className="z-10 flex items-center gap-x-2 md:flex-1 md:items-start md:justify-end ">
          <div className="flex flex-col items-center justify-between overflow-hidden text-left md:hidden md:w-6/12">
            <h5 className="my-2">{description}</h5>
            <div className="mb-8 mt-4 flex gap-2">
              {instructor?.data?.map(({ attributes, id }) => {
                if (attributes.Name === 'Group') return null;
                return (
                  <div key={id} className="overflow-hidden rounded-lg bg-red">
                    <Image
                      src={getImgUrl(attributes.DisplayPicture)}
                      height={300}
                      width={300}
                      objectFit="cover"
                      alt="Instructor"
                      priority
                    />
                    <div className=" flex h-[5rem] flex-col items-center justify-center px-1 pb-4 text-white">
                      <p className="my-auto text-center font-satoshi-medium text-sm font-semibold">
                        {attributes.Name}
                      </p>
                      <p className="text-center text-xs font-light">{attributes.Designation}</p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="flex w-full flex-row justify-evenly md:flex-col md:justify-start">
              <p className="mb-4 text-xs capitalize">
                Date:
                <span className="mt-2 block text-[0.95rem] font-extrabold">{date}</span>
              </p>
              <p className="mb-4 text-xs capitalize">
                timings:
                <span className="mt-2 block text-[0.95rem] font-extrabold">
                  {moment(eventStartTime).format('h A')} to {moment(eventEndTime).format('h A')}
                </span>
              </p>
            </div>
          </div>
          {groupImage ? (
            <div className="-mt-8 hidden w-11/12 md:block">
              <img
                src={getImgUrl(groupImage.attributes.DisplayPicture)}
                height={350}
                width={350}
                alt="instructor-group"
              />
            </div>
          ) : (
            <div className="relative hidden w-7/12 rounded-xl bg-white p-3 text-center  shadow-xl md:block md:w-60">
              {getImgUrl(DisplayPicture) && (
                <img src={getImgUrl(DisplayPicture)} height={650} width={650} alt="circle" />
              )}
              <p className="text-lg font-extrabold">{Name}</p>
              <img
                src="/assets/events/heroCurveLine.svg"
                height={40}
                width={150}
                alt="circle"
                className="mx-auto -mt-1"
              />
              <p className="mx-auto mt-2 px-4 font-satoshi-bold text-xs font-bold  capitalize md:text-sm">
                {Designation}
              </p>
              <div className="absolute -top-6 -right-14 hidden items-center justify-center rounded-lg bg-white px-4 py-2 md:flex">
                {getImgUrl(CompanyImage) && (
                  <Image
                    src={getImgUrl(CompanyImage)}
                    alt="almabetter"
                    height={35}
                    width={120}
                    priority
                    objectFit={'contain'}
                  />
                )}
              </div>
              {pastCompanies?.slice(0, 2)?.map?.(({ companyImage, designation } = {}, index) => (
                <>
                  <div
                    className={`absolute -z-10 hidden rounded-lg bg-white px-2  py-2 ${
                      !index ? '-left-40 top-16' : '-left-48 top-48'
                    } w-96 flex-col items-start justify-center text-left md:flex`}
                  >
                    <div className="ml-4">
                      <Image
                        src={getImgUrl(companyImage)}
                        alt="almabetter"
                        height={35}
                        width={120}
                        objectFit={'contain'}
                        priority
                      />
                      <p className="text-sm capitalize">Ex-{designation}</p>
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}
        </section>
        <div className="absolute -right-36 -top-52 hidden md:block ">
          <Image
            src="/assets/events/heroCircle.svg"
            height={800}
            width={700}
            objectFit="contain"
            alt="circle"
            priority
          />
        </div>
      </section>
      <section
        className={`z-30 mx-auto -mt-16 mb-2 flex w-11/12 flex-col items-start gap-y-[16px] rounded-lg bg-white p-[16px] md:w-9/12 md:flex-row md:items-center md:justify-between md:gap-[48px] md:py-[20px] md:px-[40px]`}
        style={{
          boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
        }}
      >
        <div className="flex gap-[16px]">
          <section className="flex flex-col flex-wrap items-start justify-center gap-y-2 gap-x-4 md:justify-start">
            <p className="text-base">Date</p>
            <div className="border-red-600 text-red-600 flex max-w-max items-center whitespace-nowrap border-solid bg-red-light-1 bg-opacity-60  px-4 py-1.5 font-satoshi-medium font-medium  text-red md:border-l-4">
              <img
                className="mr-2 hidden h-7 md:block"
                src="/assets/events/clock.png"
                alt="clock"
              />
              {date}{' '}
            </div>
          </section>
          <section className="flex flex-col flex-wrap items-start justify-center gap-y-2 gap-x-4 md:justify-start">
            <p className="text-base">Timings</p>
            <div className="border-red-600 text-red-600 flex max-w-max items-center whitespace-nowrap border-solid bg-red-light-1 bg-opacity-60  px-4 py-1.5 font-satoshi-medium font-medium  text-red md:border-l-4">
              <img
                className="mr-2 hidden h-7 md:block"
                src="/assets/events/calender.svg"
                alt="calender"
              />
              {timings}
            </div>
          </section>
        </div>

        <section className="flex w-full flex-col items-center justify-center text-center md:w-fit">
          {!!EventStatus && (
            <>
              {EventStatus === 'END' ? (
                <>
                  {videoLink?.includes('youtube.com') || videoLink?.includes('youtu.be') ? (
                    <>
                      {/* <p className="center mb-2 whitespace-nowrap text-center text-sm text-red">
                        <img
                          src="/assets/3dclose-icon.png"
                          alt="close"
                          className="mr-0.5 h-7"
                          loading="lazy"
                        />
                        Registration Closed
                      </p> */}
                      <a
                        // href={recordedVideoLink}
                        // target="_blank"
                        type="button"
                        onClick={openModal}
                        className=" flex w-52
                    cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-red px-4 py-2.5 text-center font-satoshi-medium font-semibold capitalize tracking-wide text-white"
                      >
                        View Recording
                      </a>
                    </>
                  ) : (
                    <button
                      className="pointer-events-none flex w-52
             cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-red px-4 py-2.5 text-center font-satoshi-medium font-semibold capitalize tracking-wide text-white opacity-50"
                    >
                      Registration Closed
                    </button>
                  )}
                </>
              ) : (
                !isEventRegister && (
                  <>
                    <p className="mb-2 whitespace-nowrap font-satoshi-medium text-sm">
                      Hurry Up! Only <span className="text-red">{registeredCount} seats left.</span>
                    </p>
                    <Primary
                      label={
                        EventStatus === 'LIVE' ? (
                          'Join Now'
                        ) : localFormData ? (
                          isLoading ? (
                            <BsArrowRepeat className="animate-spin text-2xl" />
                          ) : (
                            'Register with 1-Click'
                          )
                        ) : (
                          'Register Now'
                        )
                      }
                      onClick={() => {
                        if (localFormData) {
                          setLoading(true);
                          setRegisterWithOneClick(true);
                          return;
                        }

                        scrollToElement('RegisterSection');

                        isMobile &&
                          dispatch({
                            type: 'SET_WIDGET_SOURCE',
                            payload: sourceType.eventLandingPage,
                          });
                      }}
                      size={'large'}
                      // customStyle={'hidden md:flex'}
                    />
                  </>
                )
              )}
            </>
          )}
        </section>
      </section>

      <Transition appear show={isOpen}>
        <Dialog
          as="div"
          className="z-99 fade modal fixed inset-0 overflow-y-auto"
          onClose={closeModal}
          style={{ zIndex: 100 }}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="my-8 inline-flex w-full max-w-md transform flex-col items-center overflow-hidden rounded-2xl bg-white py-2 text-left align-middle shadow-xl transition-all lg:max-w-xl">
                <Dialog.Title as="div" className="hidden px-2 py-4 lg:block">
                  <div className="player-wrapper">
                    <div className="react-player" style={{ width: '100%', height: '100%' }}>
                      <ReactPlayer
                        url={videoLink}
                        controls
                        config={{
                          youtube: {
                            playerVars: { showinfo: 1 },
                          },
                        }}
                        width={580}
                        height={340}
                      />
                    </div>
                  </div>
                </Dialog.Title>
                <Dialog.Title as="div" className="pb-4 lg:hidden">
                  <div className="player-wrapper">
                    <div className="react-player" style={{ width: '100%', height: '100%' }}>
                      <ReactPlayer
                        url={videoLink}
                        controls
                        config={{
                          youtube: {
                            playerVars: { showinfo: 1 },
                          },
                        }}
                        height={240}
                        width={380}
                      />
                    </div>
                  </div>
                </Dialog.Title>
                <button
                  className="text-md mt-2 mb-2 w-fit rounded-lg bg-red px-4 py-2 text-white md:text-lg lg:py-2 lg:px-12"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default Hero;
